import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  BerthVisit,
  ExemptionIsps
} from '@portbase/bezoekschip-service-typescriptmodels';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";

@Component({
  selector: 'app-visit-exemptions-exemption-isps',
  templateUrl: './exemption_isps.component.html',
  styleUrls: ['./exemption_isps.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ExemptionIspsComponent extends ExemptionBaseComponent {

  @Input() exemption: ExemptionIsps;
  @Input() berthVisit : BerthVisit;

  OTHER: string = 'Other';

  securityLevel: string[] = ['',
    'SL1',
    "SL2",
    'SL3'
  ];

  activities: string[] = ['',
    'Load',
    'Discharge',
    'Other'
  ];

  accessControl: string[] = [
    'Jetty',
    'Landside'
  ];

  gangwayWatchProvidedBy: string[] = ['',
    'The ship',
    'Shore organization',
  ];

  embarking: string[] = ['',
    'Disembarking',
    'Embarking',
    'Both (embarking and disembarking)'
  ];

  showDetailedActivityDescription(activity: string) {
    return this.activities.includes(activity);
  }

  showEmbarkingSelection(shipCrewWillDisembarkOrEmbark: boolean) {
    return shipCrewWillDisembarkOrEmbark;
  }

  showSecurityMeasuresDescription(accessControl: string[]) {
    return accessControl && accessControl.length;
  }

  resetEmbarkingSelection() {
    this.exemption.embarkingSelection = null;
  }

  resetSecurityMeasuresDescription(accessControl: string[]) {
    if (!accessControl || accessControl.length === 0) {
      this.exemption.securityMeasuresDescription = '';
    }
  }
}
